import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserProfile } from '../models/user-profile.model';
import { BEARER_ONLY } from '../interceptor/token.interceptor';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {

  constructor(
    private http: HttpClient
  ) { }

  userPasses(): Observable<any> {
    return this.http
    .get<any>(environment.apiUrl + '/v2/tokens/user-passes', { context: new HttpContext().set(BEARER_ONLY, true) });
  }
  
  organizationList(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + '/v2/organization/lists');
  }

  userOrganization(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + '/v2/organization/user-lists');
  }
  
  userOrganizationPoints(): Observable<any> {
    return this.http
    .get<UserProfile>(environment.apiUrl + '/v2/organization/organization-points');
  }

  filterOrganizationList(keyword): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + `/v2/organization/lists?keyword=${keyword}`);
  }

  getQrAds(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + `/v2/organization/qr-ads`);
  }

  joinOrganization(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/organization/subscribe', JSON.stringify(item));
  }
  
  leaveOrganization(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/organization/unsubscribe', JSON.stringify(item));
  }

  getOrganizationContent(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + `/v2/organization/content`);
  }

  getBroadcastMessage(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + `/v2/organization/broadcast-message`);
  }

  getSpecialSurvey(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + `/v2/survey/special`);
  }

  sumbitSpecialSurveyAnswer(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/survey/special', JSON.stringify(item));
  }

  scanStaticQr(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/qrcode/scan-static', JSON.stringify(item));
  }

  setHomeOrganization(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/organization/set-home-org', JSON.stringify(item));
  }

  getPendingFeedback(): Observable<any> {
    return this.http
      .get<UserProfile>(environment.apiUrl + `/v2/account/user-pending-feedback`);
  }

  userFeedback(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/account/user-feedback', JSON.stringify(item));
  }

  getOrgCodes(id): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + `/v2/organization/subscription-codes?organizationId=${id}`);
  }

  getAppointmentLocations(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + '/v2/security/appointment-locations');
  }

  createAppointment(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/security/create-appointment-security', JSON.stringify(item));
  }
}
